import React from 'react';
import Icon from '../Icon';
import svg from '../icons/status-error-onlight.js';

const IconStatusErrorOnlight = (props) => <Icon {...props} svg={svg} />;

IconStatusErrorOnlight.displayName = 'IconStatusErrorOnlight';

export default IconStatusErrorOnlight;
